import React, { useContext } from 'react'
import {
  Text,
  ResponsiveBox,
  IcoMoon,
  FilterIcon,
} from '@usap/uicomponents'

import { SearchContext } from '../../common/context/SearchContextProvider'

export default function FilterResultLabel() {
  const {
    searchState: { sidebarStatus },
    setSearchContext,
  } = useContext(SearchContext)

  return (
    <ResponsiveBox
      id="filterResults"
      direction="row"
      alignSelf="center"
      align="center"
      height="56px"
      gap="xsmall"
      onClick={() => setSearchContext({ sidebarStatus: !sidebarStatus })}
      fxIf={{ large: false, other: true }}
    >
      <>
        <Text size="16px" weight={700} color="blueLink">
          Filter results
        </Text>
        <IcoMoon icon={FilterIcon} color="blueLink" size="24px" />
      </>
    </ResponsiveBox>

  )
}
